import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { MainLayout } from 'layouts/MainLayout'
import { SignedInLayout } from 'layouts/SignedInLayout'

import { SIGNIN, BOOK, LOGISTIC, PRICES, ROUTES, USERS, PLAYGROUND, WEBSITE_BOOKINGS, BLACKLIST } from 'constants/urls'

import { BookPage } from 'routes/BookPage'
import { UsersPage } from 'routes/UsersPage'
import { SignInPage } from 'routes/SignInPage'
import { PricesPage } from 'routes/PricesPage'
import { RoutesPage } from 'routes/RoutesPage'
import { LogisticPage } from 'routes/LogisticPage'
import { PlaygroundPage } from 'routes/PlaygroundPage'
import { WebsiteBookingsPage } from 'routes/WebsiteBookingsPage'
import { BlacklistPage } from 'routes/BlacklistPage'

export class App extends Component {
  render() {
    return (
      <MainLayout>
        <Switch>
          <Route exact path={SIGNIN} component={SignInPage} />

          <SignedInLayout>
            <Route exact path={BOOK} component={BookPage} />
            <Route exact path={USERS} component={UsersPage} />
            <Route exact path={PRICES} component={PricesPage} />
            <Route exact path={ROUTES} component={RoutesPage} />
            <Route exact path={LOGISTIC} component={LogisticPage} />
            <Route exact path={PLAYGROUND} component={PlaygroundPage} />
            <Route exact path={WEBSITE_BOOKINGS} component={WebsiteBookingsPage} />
            <Route exact path={BLACKLIST} component={BlacklistPage} />
          </SignedInLayout>

          <Redirect to={SIGNIN} />
        </Switch>
      </MainLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App/App.js